import { render, staticRenderFns } from "./parametres.vue?vue&type=template&id=512f5d1e"
import script from "./parametres.vue?vue&type=script&lang=js"
export * from "./parametres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports